import { MutationTree } from 'vuex';
import { Item, ModuleState } from './types'
import { initialState } from './index'

export const mutations: MutationTree<ModuleState> = {
  handleResponse(state, payload: { items: Item[] }) {
    state.items = payload.items;
  },
  handleResponseFetchBy(state, payload: { item: Item }) {
    state.item = payload.item;
  },
  reset(state) { Object.assign(state, initialState) },
}
